<section class="ei-popup edit-role-wrapper">
  <form class="ei-popup-form">
    <div class="row d-flex">
      <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
        <span class="form-inline-new">
          <label>Segment</label>
        </span>
        <span>
          <p class="edit-defaults">{{ masterSegment }}</p>
        </span>
      </div>
      <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4 lob-edit-lobName">
        <span class="form-inline-new">
          <label>LOB</label>
        </span>
        <span
          matTooltipClass="my-custom-tooltip"
          matTooltip="{{ lob }}"
          matTooltipPosition="below"
          matTooltipClass="custom-tooltip"
        >
          <p class="edit-defaults lob-default-name">{{ lob }}</p>
        </span>
      </div>
      <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4 lob-edit-subLob-name">
        <span class="form-inline-new">
          <label>Sub LOB</label>
        </span>
        <span
          matTooltipClass="my-custom-tooltip"
          matTooltip="{{ subLobName }}"
          matTooltipPosition="below"
          matTooltipClass="custom-tooltip"
        >
          <p class="lob-default-name">{{ subLobName }}</p>
        </span>
      </div>
    </div>
    <div class="row d-flex">
      <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
        <span class="form-inline-new">
          <label>Role</label>
        </span>
        <span>
          <p class="lob-default-name">{{ role }}</p>
        </span>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 col-xs-6 ca-ad-block">
        <span class="form-inline-new">
          <label>User<b class="text-danger">*</b></label>
        </span>
        <div class="lob-chip-field sublob-architects lob-border">
          <ng-container class="example-chip-list">
            <mat-form-field
              (click)="focusOnInput()"
              class="inline-form-edit sublob-edit-architects chip-fields"
              floatLabel="never"
            >
              <mat-chip-grid #chipList1>
                @for (user of selectedUsers; track user) {
                <mat-chip-row class="stk-mat-chip" (removed)="removeSubLobUsers(user)">
                  <span title="{{ user.MSId || user.msid }}" style="cursor: pointer;">
                    {{ user.displayName }}
                  </span>
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-row>
                }
              </mat-chip-grid>
              <input
                #inputEditUser
                class="lob-chip-input"
                placeholder="Search by Name/Mail"
                [matAutocomplete]="auto"
                (keyup)="keyUpSearch($event)"
                [matChipInputFor]="chipList1"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                required
              />
              <mat-autocomplete
                showPanel="true"
                class="lob-options-list"
                #auto="matAutocomplete"
                (optionSelected)="AddUsers($event)"
              >
                @for (user of users; track user) {
                <mat-option
                  [disabled]="checkexistArchitects(user)"
                  title="{{ user.MSId }}<{{ user.displayName }}>({{ user.mail }})"
                  [value]="user"
                >
                  {{ user.MSId }}<{{ user.displayName }}>({{ user.mail }})
                </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </ng-container>
        </div>
        @if (!selectedUsers?.length) {
        <div class="help-block uitk-c-input__message--error">
          User is required
        </div>
        }
      </div>
    </div>
  </form>
  <div class="pull-right subLob-edit-apply me-3">
    <button
      mat-mdc-raised-button
      (click)="submitEditRole()"
      [disabled]="!selectedUsers?.length"
      class="add-apply m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size"
    >
      Submit
    </button>
  </div>
</section>
